import { Link } from "@tanstack/react-router";
import { Button } from "./ui/button";

export function DefaultNotFound() {
  return (
    <div className="space-y-2 p-2">
      <p>De pagina die je zoekt bestaat niet.</p>
      <p className="flex flex-wrap items-center gap-2">
        <Button type="button" onClick={() => window.history.back()}>
          Ga terug
        </Button>
        <Button asChild variant="secondary">
          <Link to="/">Startpagina</Link>
        </Button>
      </p>
    </div>
  );
}
